import { endOfDay } from '../../analytics/shared/analysis-dates';

/** DataPlatform reads an end date as an inclusive instant; a stored one the picker still holds is kept as saved. */
export function inclusiveEndDate(picked: Date, stored?: string): string {
  if (stored && new Date(stored).getTime() === picked.getTime()) {
    return stored;
  }
  return endOfDay(picked).toISOString();
}
